import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { request, gql } from "graphql-request";
import { hyGraphToken, endpointURL } from "../../ThemeModule";
import PageHeader from "../../components/PageHeader";
import "./service.scss";
import { ParallaxBanner } from "react-scroll-parallax";
import Seo from "../../components/Seo";
import { toDescription } from "../../seo/siteMeta.mjs";

const ServiceDetailsLayout = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      const endpoint = endpointURL;
      const query = gql`
        query Service($slug: String!) {
          service(where: { slug: $slug }) {
            bannerImage {
              url
            }
            bottomContent {
              html
            }
            featureImage {
              url
            }
            id
            listData {
              ... on ServiceListContent {
                id
                title
                content
              }
            }
            title
            slug
            topContent {
              html
              text
            }
          }
        }
      `;

      const headers = {
        Authorization: `Bearer ${hyGraphToken}`,
      };

      try {
        const data = await request(endpoint, query, { slug }, { headers });
        setPost(data.service);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  return (
    <>
      {!loading && !post && (
        <Seo
          path={`/service/${slug}`}
          title="Service Not Found"
          description="The service you are looking for does not exist or has moved."
          noindex
        />
      )}
      {post && (
        <Seo
          path={`/service/${slug}`}
          title={post.title.trim()}
          description={toDescription(post.topContent?.text)}
          image={post.featureImage?.url || post.bannerImage?.url}
          imageAlt={post.title.trim()}
        />
      )}

      <PageHeader title={post ? post.title : "Loading..."} />

      <div className="serviceDetail_page">
        <div className="max-w-container shape-1 shape-2 relative mx-auto px-4 pt-20 pb-20">
          {loading ? (
            <div className="loader text-center">Loading...</div>
          ) : error ? (
            <div className="error-message text-red-500 text-center">
              <p>Failed to load Service: {error}</p>
            </div>
          ) : (
            post && (
              <div className=" flex flex-wrap justify-center -mx-4">
                <div className="w-full lg:w-8/12 px-4">
                  <div className="service_top_content relative text-center">
                    {post.topContent?.html && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: post.topContent.html,
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className="w-full mb-5 md:w-8/12 px-4">
                  {post.bannerImage?.url && (
                    <ParallaxBanner
                      layers={[{ image: post.bannerImage.url, speed: -20 }]}
                      className="serviceImg service_left_img"
                    />
                  )}
                </div>
                <div className="w-full md:w-4/12 px-4">
                  <div className="serviceImg service_right_img">
                    {post.featureImage?.url && (
                      <img
                        src={post.featureImage.url}
                        alt={post.title}
                        className="w-full"
                      />
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-12/12 px-4">
                  <div className="service_list_content mt-20">
                    {post.listData?.map((item) => (
                      <div key={item.id} className="serv_list_item">
                        <div className="service_list_inner">
                          <div className="serviceList_content">
                            <h4>{item.title}</h4>
                            <p>{item.content}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="w-full lg:w-8/12 px-4 mt-8">
                  <div className="service_bottom_content text-center">
                    {post.bottomContent?.html && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: post.bottomContent.html,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default ServiceDetailsLayout;
